import { render, staticRenderFns } from "./addSignNamePage.vue?vue&type=template&id=065498e2&scoped=true"
import script from "./addSignNamePage.vue?vue&type=script&lang=js"
export * from "./addSignNamePage.vue?vue&type=script&lang=js"
import style0 from "./addSignNamePage.vue?vue&type=style&index=0&id=065498e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065498e2",
  null
  
)

export default component.exports